import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { authActions } from "../../redux/actions";
import noqLogoNew from "../../assets/icons/NO-QLogo-new.svg";
import InputField from "../../assets/components/InputField";
import PrimaryButton from "../../assets/components/PrimaryButton";

const Login = () => {
    const [loginInfo, setLoginInfo] = useState({
        email: "",
        password: "",
        rememberMe: false,
    });
    const [forgetEmail, setForgetEmail] = useState("");
    const [isForgotPassword, setIsForgotPassword] = useState(false);

    const dispatch = useDispatch();
    const { isLoggingIn, isRequestingPasswordReset } = useSelector((state) => state.auth);

    const handleLogin = () => {
        dispatch(
            authActions.loginUser(
                { email: loginInfo.email, password: loginInfo.password },
                loginInfo.rememberMe
            )
        );
    };

    const handleRequestPasswordReset = () => {
        dispatch(authActions.resquestPasswordReset({ email: forgetEmail }));
    };

    return (
        <div className="bg-background-dark min-h-screen font-sans relative px-4">
            <img
                src={noqLogoNew}
                alt="NO-Q"
                className="absolute top-8 left-8 w-24 max-sm:w-20"
            />

            <div className="min-h-screen flex flex-col items-center justify-center text-white">
                <div className="w-full max-w-[520px]">
                    {isForgotPassword ? (
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleRequestPasswordReset();
                            }}
                        >
                            <div className="text-center mb-8">
                                <h1 className="text-4xl sm:text-5xl font-bold">Forgot Password</h1>
                                <p className="text-sm mt-1">
                                    Enter your email to receive a password reset link
                                </p>
                            </div>

                            <InputField
                                label="Email Address"
                                required
                                type="email"
                                name="forgetEmail"
                                placeholder="Enter your email address"
                                value={forgetEmail}
                                onChange={(e) => setForgetEmail(e.target.value)}
                            />

                            <PrimaryButton
                                type="submit"
                                disabled={isRequestingPasswordReset}
                                className="w-full mt-2"
                            >
                                {isRequestingPasswordReset ? "Submitting..." : "Submit"}
                            </PrimaryButton>
                        </form>
                    ) : (
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleLogin();
                            }}
                        >
                            <h1 className="text-4xl sm:text-5xl font-bold text-center mb-8">
                               Organizer Sign-in
                            </h1>

                            <InputField
                                label="Email Address"
                                required
                                type="email"
                                name="email"
                                placeholder="Enter your email"
                                value={loginInfo.email}
                                onChange={(e) =>
                                    setLoginInfo((prev) => ({
                                        ...prev,
                                        email: e.target.value,
                                    }))
                                }
                            />

                            <InputField
                                label="Password"
                                required
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={loginInfo.password}
                                onChange={(e) =>
                                    setLoginInfo((prev) => ({
                                        ...prev,
                                        password: e.target.value,
                                    }))
                                }
                            />

                            <div className="flex justify-between items-center text-sm mb-2">
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={loginInfo.rememberMe}
                                        onChange={() =>
                                            setLoginInfo((prev) => ({
                                                ...prev,
                                                rememberMe: !prev.rememberMe,
                                            }))
                                        }
                                    />
                                    Remember Me
                                </label>
                                <span
                                    className="font-semibold cursor-pointer"
                                    onClick={() => setIsForgotPassword(true)}
                                >
                                    Forgot Password?
                                </span>
                            </div>

                            <PrimaryButton
                                type="submit"
                                disabled={isLoggingIn}
                                className="w-full mt-6"
                            >
                                {isLoggingIn ? "Logging in..." : "Sign-in"}
                            </PrimaryButton>
                        </form>
                    )}

                    <p className="text-center text-sm mt-8">
                        Don't have an account?{" "}
                        <Link className="underline font-semibold" to={"/register"}>
                            Click here to join no-q
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
